"use client";
import { AllBenchmarkListItem } from "@/type/commonTypes";
import { FundNavSeries } from "@/type/comparePageTypes";
import React, { useEffect, useMemo, useState } from "react";
import SelectBenchmarkDropdown from "../ui/SelectBenchmarkDropdown";
import CompareFundsNavChart from "../charts/CompareFundsNavChart";
import { getAllIndexNav } from "@/utils/commonServerFunctions";

export default function CompareNavChartSection({ fundsNav, benchmarkList }: { fundsNav: FundNavSeries[]; benchmarkList: AllBenchmarkListItem[] }) {
  const [selectedBenchmarks, setSelectedBenchmarks] = useState<AllBenchmarkListItem[]>([]);
  const [benchmarkData, setBenchmarkData] = useState<FundNavSeries[]>([]);

  useEffect(() => {
    const indId = selectedBenchmarks.map((v) => v.ind_id ?? 9);
    if (indId.length <= 0) return setBenchmarkData([]);
    if (indId.length > 3) return;

    const fetchData = async () => {
      const res = await getAllIndexNav(indId, "25y");
      setBenchmarkData(res);
    };

    fetchData();
  }, [selectedBenchmarks]);

  const chartSeries = useMemo<FundNavSeries[]>(() => {
    if (!fundsNav) return [];
    return benchmarkData.length > 0 ? [...fundsNav, ...benchmarkData] : fundsNav;
  }, [fundsNav, benchmarkData]);

  return (
    <>
      <SelectBenchmarkDropdown lists={benchmarkList} onChange={(items) => setSelectedBenchmarks(items)} />
      <CompareFundsNavChart funds={chartSeries} />
    </>
  );
}
